"use strict";

var LoggerInstance = require("js-logger").get("SmartyStreets");

var SmartyStreetsAutocomplete = require("./SmartyStreetsAutocomplete");
var SmartyStreetsVerify = require("./SmartyStreetsVerify");

var SmartyStreetsApi = require("../api/SmartyStreetsApi");

var ApiHelper = require("../shared/ApiHelper");

// This only works currently having a single SmartyStreets address form on a page at a time.
//	If we need multiple, we will need to create a new instance of SmartyStreetsVerify and SmartyStreetsAutocomplete on each initialize call.
var SmartyStreets = {
	initialize: function (smartyStreetsOptions) {
		smartyStreetsOptions = smartyStreetsOptions || {};
		window.smartyStreetsInstances = window.smartyStreetsInstances || {};

		var addressStandardizationWizard = window.AccountStore.get("wizardAddressStandardization");
		var isSmartyStreetsEnabled = addressStandardizationWizard && addressStandardizationWizard.isEnabled === "true";

		if (!isSmartyStreetsEnabled) {
			LoggerInstance.debug("SmartyStreets is not configured for use.");
			return;
		}
		if (!smartyStreetsOptions.instanceName) {
			LoggerInstance.error("An 'instanceName' must be provided.");
			return;
		}
		if (window.smartyStreetsInstances[smartyStreetsOptions.instanceName]) {
			LoggerInstance.error(`A SmartyStreets instance already exists with the '${smartyStreetsOptions.instanceName}' instanceName.`);
		}

		var $addressForm = $(smartyStreetsOptions.addressFormSelector);
		var themeId = $addressForm.attr("data-theme") || $("body").attr("data-theme");

		if ($addressForm.length && themeId) {
			SmartyStreetsApi.getSmartyStreetsHtml(themeId).done((data) => {
				if (data.success) {
					// Just got the Popup and Autocomplete html
					smartyStreetsOptions = Object.assign(smartyStreetsOptions, data.model);
					smartyStreetsOptions.restrictedCountries = addressStandardizationWizard.restrictedCountries;

					// Setup the Address Verify
					var smartyStreetsVerifyInstance = new SmartyStreetsVerify(smartyStreetsOptions);

					// Save the SmartyStreetVerifyInstance
					window.smartyStreetsInstances[smartyStreetsOptions.instanceName] = smartyStreetsVerifyInstance;

					var smartyStreetsApiKeyWizard = window.AccountStore.get("wizardSmartyStreetsApiKey");
					if (smartyStreetsApiKeyWizard && smartyStreetsApiKeyWizard.apiKey) {
						// Setup the Autocomplete
						// Do not need to reference it again
						var smartyStreetsAutocompleteInstance = new SmartyStreetsAutocomplete(smartyStreetsOptions);
					}
				}
			});
		}
	},

	initializeForCreateAccount: function() {
		// Setting up the createAccountForm SmartyStreets integration
		this._initializeForm("#createAccountForm", "createAccountForm");
	},

	initializeForCreateGiftAccount: function() {
		this._initializeForm("#createGiftAccountForm", "createGiftAccountForm");
	},

	initializeForEventRegistration: function(id) {
		this._initializeForm(`#${id} form`, `eventRegistration${id}`);
	},

	initializeForOtherAddressesAdd: function() {
		this._initializeForm("#addOtherAddresses", "otherAddressesAdd");
	},

	initializeForOtherAddressesEdit: function(id) {
		this._initializeForm("#editOtherAddresses-" + id, `otherAddressesEdit${id || ""}`);
	},

	initializeForPrimaryContactInformation: function() {
		// Setting up the primaryContactInformationForm SmartyStreets integration
		this._initializeForm("#primaryContactInformationForm", "primaryContactInformation");
	},

	initializeForSubscriptionPurchase: function(id) {
		this._initializeForm(`#${id} form`, `subscription${id}`);
	},

	removeEventRegistration: function(id) {
		delete window.smartyStreetsInstances[`eventRegistration${id}`];
	},

	removeOtherAddressEdit: function(id) {
		delete window.smartyStreetsInstances[`otherAddressesEdit${id || ""}`];
	},

	_initializeForm: function(formSelector, instanceName) {
		var smartyStreetsOptions = {
			address1InputSelector: `${formSelector} input[data-component='accountAddressLine1']`,
			address2InputSelector: `${formSelector} input[data-component='accountAddressLine2']`,
			address3InputSelector: `${formSelector} input[data-component='accountAddressLine3']`,
			address4InputSelector: `${formSelector} input[data-component='accountAddressLine4']`,
			addressFormSelector: formSelector,
			cityInputSelector: `${formSelector} input[data-component='accountAddressCity']`,
			countryInputSelector: `${formSelector} select[name='address.country']`,
			instanceName,
			postalCodeInputSelector: `${formSelector} input[data-component='accountAddressPostalCode']`,
			stateInputSharedSelector: `${formSelector} [data-shared-name='address.state.field']`,
			stateInputSelectSelector: `${formSelector} select[name='address.state']`,
			stateInputTextSelector: `${formSelector} input[name='address.state']`
		};
		this.initialize(smartyStreetsOptions);
	},

	clearVerification: function(instanceName) {
		if (!instanceName) {
			return ApiHelper.logErrorAndReturnResolvedDeferred(LoggerInstance, "An 'instanceName' must be provided.");
		}

		if (window.smartyStreetsInstances && window.smartyStreetsInstances[instanceName] && (typeof window.smartyStreetsInstances[instanceName].clearVerification === "function")) {
			return window.smartyStreetsInstances[instanceName].clearVerification();
		}

		// This could occur if SmartyStreets was not initialized because an ApiKey was not present
		return ApiHelper.logDebugAndReturnResolvedDeferred(LoggerInstance, `A SmartyStreets instance with the instanceName '${instanceName}' does not exist.`);
	},

	verifyAddress: function (instanceName) {
		if (!instanceName) {
			return ApiHelper.logErrorAndReturnResolvedDeferred(LoggerInstance, "An 'instanceName' must be provided.");
		}

		if (window.smartyStreetsInstances && window.smartyStreetsInstances[instanceName] && (typeof window.smartyStreetsInstances[instanceName].verifyAddress === "function")) {
			return window.smartyStreetsInstances[instanceName].verifyAddress();
		}

		// This could occur if SmartyStreets was not initialized because an ApiKey was not present
		return ApiHelper.logDebugAndReturnResolvedDeferred(LoggerInstance, `A SmartyStreets instance with the instanceName '${instanceName}' does not exist.`);
	}
};

module.exports = SmartyStreets;



// WEBPACK FOOTER //
// ./Javascript/accountComponents/SmartyStreets.jsx